














import { Vue, Component } from 'vue-property-decorator';
@Component
export default class Dataprocess extends Vue {
  bread = [{ name: '数据' }, { name: '数据加工' }];
}
